var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-3c615fb1]{font-size:15px;text-align:justify}img[data-v-3c615fb1]{position:relative;clear:both;width:100%;height:100%}#background[data-v-3c615fb1]{width:100%;height:1800px;background-image:url(" + escape(require("../../../public/pic/product/accompany/b1.png")) + ")}", ""]);

// exports
